import dayjs from 'dayjs'
import isToday from 'dayjs/plugin/isToday'
import isYesterday from 'dayjs/plugin/isYesterday'

dayjs.extend(isToday)
dayjs.extend(isYesterday)

export function ts() {
  return Math.round(Date.now() / 1000)
}

export function messageDateFormat(date: string | number) {
  const _day = dayjs(date)
  if (_day.isToday()) {
    return `Today ${_day.format('HH:mm')}`
  }
  if (_day.isYesterday()) {
    return `Yesterday ${_day.format('HH:mm')}`
  }
  if (_day.year() !== dayjs(new Date()).year()) {
    return `${_day.format('YYYY-MM-DD HH:mm')}`
  } else {
    return `${_day.format('MM-DD HH:mm')}`
  }
}
